import React, {useState} from 'react';
import {Box, HStack, Modal, ModalBody, ModalContent, ModalOverlay, VStack} from '@chakra-ui/react';
import {TextG12, TextG14, TextG16, TextG20, TextG24} from '../../components/typography';
import BookmarkPlaces from './index';

interface IntroPlacesProps {
  onSessionBookmarkCountChange?: (count: number) => void;
  showExitConfirmation?: boolean;
  onExitConfirmationClose?: () => void;
  onExitConfirmationSkip?: () => void;
}

const BULLETS = [
  'Browse places nearby — coffee shops, bars, hidden gems.',
  'Save anywhere you might want to try.',
  'See which neighbors love the same spots you do.',
];

const IntroPlaces = ({
  onSessionBookmarkCountChange,
  showExitConfirmation = false,
  onExitConfirmationClose,
  onExitConfirmationSkip,
}: IntroPlacesProps) => {
  const [showModal, setShowModal] = useState(true);

  return (
    <>
      <Modal isOpen={showModal} onClose={() => setShowModal(false)} isCentered size="sm">
        <ModalOverlay bg="rgba(0, 0, 0, 0.4)" />
        <ModalContent mx={4} borderRadius="24px" py={6} px={4}>
          <ModalBody p={0}>
            <VStack spacing={6} align="stretch">
              <VStack spacing={2}>
                <TextG24 fontSize="26px" fontWeight="700" textAlign="center" lineHeight="34px">
                  Let's start saving
                </TextG24>
                <TextG24
                  fontSize="26px"
                  fontWeight="700"
                  color="#C9136B"
                  textAlign="center"
                  lineHeight="34px">
                  your neighborhood
                </TextG24>
              </VStack>

              <VStack spacing={4} align="stretch">
                {BULLETS.map((text, i) => (
                  <HStack key={i} align="center" spacing={4}>
                    <Box
                      w="40px"
                      h="40px"
                      borderRadius="full"
                      bg="rgba(183, 28, 99, 0.1)"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      flexShrink={0}>
                      <TextG20 lineHeight="24px" fontWeight="700" color="#C9136B">
                        {i + 1}
                      </TextG20>
                    </Box>
                    <TextG16 lineHeight="24px" pt={1} fontWeight="500">
                      {text}
                    </TextG16>
                  </HStack>
                ))}
              </VStack>

              <Box position="relative" pt={3} mt="54px !important">
                <Box
                  position="absolute"
                  top="-20px"
                  left="16px"
                  bg="#FAE7F0"
                  borderTopRadius="8px"
                  px="12px"
                  py="6px"
                  zIndex={1}>
                  <TextG12 fontWeight="700" color="#C9136B">
                    Bonus Tip
                  </TextG12>
                </Box>
                <Box bg="#F8F6F7" borderRadius="8px" p="16px" border="2px solid #F4CFE2">
                  <TextG14 fontWeight="500" lineHeight="22px" color="#363636">
                    Saved spots become perk-eligible — you'll see Insiders offers as you go.
                  </TextG14>
                </Box>
              </Box>

              <Box
                mt="24px !important"
                as="button"
                bg="#C9136B"
                color="white"
                py={4}
                borderRadius="full"
                onClick={() => setShowModal(false)}
                _active={{transform: 'scale(0.98)'}}
                transition="all 0.2s">
                <TextG16 fontWeight="500">See What's Interesting Nearby</TextG16>
              </Box>
            </VStack>
          </ModalBody>
        </ModalContent>
      </Modal>

      <BookmarkPlaces
        embedded
        onSavedCountChange={onSessionBookmarkCountChange}
        showExitConfirmation={showExitConfirmation}
        onExitConfirmationClose={onExitConfirmationClose}
        onExitConfirmationSkip={onExitConfirmationSkip}
      />
    </>
  );
};

export default IntroPlaces;
